export default {"src":"/_next/static/media/HIVE.581cb99e.svg","height":18,"width":18};